(ns practitest.frontend.global-fields-settings.utils
  (:require [clojure.string :as str]))

(defn extract-field-values
  "Extract all unique values from a collection of fields.
   Handles :possible_values, :values, and :list_values keys.
   Flattens nested arrays."
  [fields]
  (distinct (mapcat (fn [field]
                      (let [values (or (:possible_values field)
                                       (:values field)
                                       (:list_values field)
                                       [])]
                        (cond
                          (sequential? values) (flatten values)
                          (map? values) (mapcat val values)
                          :else [values])))
                    fields)))

(defn sanitize-field-value
  "Sanitize a field value by converting to string and replacing non-alphanumeric characters with underscores."
  [value]
  (str/replace (str value) #"[^a-zA-Z0-9]" "_"))

(defn format-last-refreshed [timestamp]
  (when timestamp
    (let [date (js/Date. timestamp)
          hours (.getHours date)
          minutes (.getMinutes date)
          seconds (.getSeconds date)
          pad #(if (< % 10) (str "0" %) (str %))]
      (str (pad hours) ":" (pad minutes) ":" (pad seconds)))))